/**
 * Přístup k server-injected bootstrapu (`window.__ETTS__`). Produkční SPA shell
 * (`templates/spa.html`) ho naplní; v devu je stub v `index.html`.
 */
export function ettsBootstrap(): Window["__ETTS__"] {
  if (typeof window !== "undefined" && window.__ETTS__) return window.__ETTS__;
  return {
    csrfToken: null,
    csrfHeader: "X-CSRF-TOKEN",
    locale: "cs",
    serverTimeZone: "UTC",
    user: null,
    version: "dev",
    buildProfile: "dev",
    dev: true,
  };
}

export function csrfHeaders(): Record<string, string> {
  const b = ettsBootstrap();
  return b.csrfToken ? { [b.csrfHeader]: b.csrfToken } : {};
}
